import { render, staticRenderFns } from "./MyCardDecks.vue?vue&type=template&id=8820f9a8&"
import script from "./MyCardDecks.vue?vue&type=script&lang=js&"
export * from "./MyCardDecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports